import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CreativeTagExport from './CreativeTagExport';
import Mixpanel from '../shared/Mixpanel';
import PixelExport from './PixelExport';
import './ExportOptionsMenu.css';

class ExportOptionsMenu extends Component {
  constructor(props) {
    super(props);
    this.showMenu = this.showMenu.bind(this);
    this.showExportModal = this.showExportModal.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.trackBulkExport = this.trackBulkExport.bind(this);
    this.state = { anchorEl: null };
  }

  showMenu(event) {
    Mixpanel.track('Opened Export Menu List', {
      rtbVersion: this.props.rtbVersion
    });
    this.setState({ anchorEl: event.currentTarget });
  }

  showExportModal() {
    this.setState({ anchorEl: null, exportModalOpen: true });
  }

  hideMenu() {
    this.setState({ anchorEl: null });
  }

  hideModal() {
    this.setState({ exportModalOpen: false });
  }

  trackBulkExport() {
    Mixpanel.track('Bulk Export Clicked', {
      rtbVersion: this.props.rtbVersion
    });
  }

  render() {
    const ExportModal = () =>
      this.props.rtbVersion === '2.2' ? (
        <CreativeTagExport
          getCreatives={this.props.getCreatives}
          hideModal={this.hideModal}
          modalOpen={this.state.exportModalOpen}
          AdMarkupService={this.props.AdMarkupService}
        />
      ) : (
        <PixelExport
          getCreatives={this.props.getCreatives}
          hideModal={this.hideModal}
          modalOpen={this.state.exportModalOpen}
        />
      );

    const exportModalLabel =
      this.props.rtbVersion === '2.2'
        ? 'Generate Creative Tags'
        : 'Generate Impression Pixels';

    // TODO: maybe just pass in group ID directly
    const bulkExportUrl = `/creative_exports/${
      this.props.CreativeGroupService.group.id
    }`;

    return (
      <Fragment>
        <button
          className="btn btn-primary mr1 pr1"
          aria-owns={this.state.anchorEl ? 'export-options-menu' : null}
          aria-haspopup="true"
          onClick={this.showMenu}
        >
          Export
          <i className="material-icons small-icon pl1">unfold_more</i>
        </button>
        <Menu
          id="export-options-menu"
          className="export-options-menu"
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.hideMenu}
        >
          <MenuItem>
            <a
              className="bulk-export-link"
              onClick={this.trackBulkExport}
              href={bulkExportUrl}
              download
            >
              CSV Export
            </a>
          </MenuItem>
          <MenuItem onClick={this.showExportModal}>{exportModalLabel}</MenuItem>
        </Menu>
        {this.state.exportModalOpen && <ExportModal />}
      </Fragment>
    );
  }
}

ExportOptionsMenu.propTypes = {
  getCreatives: PropTypes.func.isRequired,
  rtbVersion: PropTypes.string.isRequired,
  AdMarkupService: PropTypes.object.isRequired,
  CreativeGroupService: PropTypes.object.isRequired
};

export default ExportOptionsMenu;
